export default __webpack_public_path__ + "static/media/Arber-Jashari.2bee154c.jpg";